import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

import client from '../api/client';

// System permissions gate what auth entry points the UI offers.
// GET /api/system/info -> { showLogin, showRegistration, adminLevel, ... }.
// (Note: the legacy plan called these allowLogin/allowRegistration; the new
// server names them showLogin/showRegistration.)
const SystemContext = createContext(null);

export function SystemProvider({ children }) {
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    client
      .get('/system/info')
      .then(({ data }) => {
        if (active) setInfo(data);
      })
      .catch(() => {
        if (active) setInfo(null);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  const value = useMemo(
    () => ({
      info,
      loading,
      // Fail closed: only surface login/registration when the server enables them.
      showLogin: !!info?.showLogin,
      showRegistration: !!info?.showRegistration,
    }),
    [info, loading]
  );

  return <SystemContext.Provider value={value}>{children}</SystemContext.Provider>;
}

export function useSystemInfo() {
  const ctx = useContext(SystemContext);
  if (!ctx) {
    throw new Error('useSystemInfo must be used within a SystemProvider');
  }
  return ctx;
}
